import { TRootState } from "@/store/app/store";

export const tripDataSelector = (state: TRootState) => state.tripInfo;
export const tripDataLoadingSelector = (state: TRootState) =>
  state.tripInfo.loading;
export const distanceDifferenceSelector = (state: TRootState) =>
  state.tripInfo.distanceDifference;
